import React from "react";
import { Box, Typography, Button } from "@mui/material";

const PopDesignMenu = ({ toggleDrawer, editItem, headerItemData }) => {
  const popupDesignList = [];

  return (
    <Box
      sx={{
        borderRadius: "5px",
        width: "100%",
        height: "calc(100vh - 200px)",
        margin: "0 auto",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#333",
            color: "#fff",
            padding: "5px",
            marginBottom: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", fontSize: "16px" }}
          >
            Header Item {editItem.index + 1} - Popup Design
          </Typography>
          <Button
            variant="text"
            sx={{ fontWeight: "bold", color: "#fff" }}
            onClick={() => {
              toggleDrawer(true, editItem.index, "menu");
            }}
          >
            Back
          </Button>
        </Box>

        {popupDesignList.map((item) => {
          return (
            <Box
              key={item.key}
              sx={{
                height: "50px",
                display: "flex",
                alignItems: "center",
                padding: "0 5px",
                borderBottom: "2px solid #B5B5B5",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  columnGap: "10px",
                }}
              >
                <Typography variant="subtitle1">Popup {item.name}</Typography>

                <Button
                  variant="outlined"
                  onClick={() =>
                    toggleDrawer(
                      editItem.open,
                      editItem.index,
                      "picker",
                      item.key,
                      editItem.item
                    )
                  }
                  sx={{
                    background:
                      headerItemData[editItem.index][editItem.item][item.key],
                    width: "40px",
                    height: "40px",
                    minWidth: "40px",
                    border: "1px solid #ccc",
                  }}
                ></Button>
              </Box>
            </Box>
          );
        })}
      </Box>
      <Button
        variant="contained"
        color="success"
        fullWidth
        sx={{
          fontSize: "12px",
          padding: "6px",
          width: "90%",
          borderRadius: "50px",
          marginBottom: "15px",
        }}
      >
        Save
      </Button>
    </Box>
  );
};

export default PopDesignMenu;
